// Функция для добавления анимаций при скролле
export const initScrollAnimations = () => {
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, observerOptions);

  // Наблюдаем за всеми элементами с классом scroll-fade
  document.querySelectorAll('.scroll-fade').forEach(el => {
    observer.observe(el);
  });
};